import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

export default function Footer() {
  const baseUrl = 'https://qallix.com';
  
  return (
    <footer style={{ 
      backgroundColor: '#000', 
      color: '#fff', 
      padding: '2rem 0'
    }}>
      <div className="container" style={{ 
        maxWidth: '1100px', 
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        {/* Three Columns Row */}
        <div style={{ 
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          marginBottom: '3rem'
        }}>
          {/* Company */}
          <div style={{ 
            flex: '1 1 200px', 
            marginBottom: '2rem',
            padding: '0 1rem'
          }}>
            <h4 style={{ fontWeight: 'bold', marginBottom: '1rem', fontSize: '25px' }}>Company</h4>
            <ol style={{ listStyle: 'none', padding: 0 }}>
              {[
                { name: 'Home', url: `/` },
                { name: 'About', url: `${baseUrl}/about-us` },
                { name: 'Features', url: `${baseUrl}/qallix-features` },
                { name: 'Brand Management', url: `${baseUrl}/brand-management` },
                { name: "Qallix Partner's Program", url: `${baseUrl}/partner` },
                { name: 'Pricing', url: `${baseUrl}/pricing` },
                { name: 'Blog', url: `${baseUrl}/blogs` },
                { name: 'Our Alliances', url: `${baseUrl}/our-alliances` },
                { name: 'QAgent — Your AI eCommerce Assistant', url: `${baseUrl}/qagent` },
              ].map(item => (
                <li key={item.name} style={{ marginBottom: '0.5rem' }}>
                  <a 
                    href={item.url} 
                    style={{ color: '#fff', textDecoration: 'none' }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* Legal */}
          <div style={{ 
            flex: '1 1 150px', 
            marginBottom: '2rem',
            padding: '0 1rem'
          }}>
            <h4 style={{ fontWeight: 'bold', marginBottom: '1rem', fontSize: '25px' }}>Legal</h4>
            <ol style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <a 
                  href={`${baseUrl}/our-terms`} 
                  style={{ color: '#fff', textDecoration: 'none' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Our Terms
                </a>
              </li>
              <li>
                <a 
                  href={`${baseUrl}/privacy-policy`} 
                  style={{ color: '#fff', textDecoration: 'none' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
            </ol>
          </div>

          {/* Contact */}
          <div style={{ 
            flex: '1 1 150px', 
            marginBottom: '2rem',
            padding: '0 1rem'
          }}>
            <h4 style={{ fontWeight: 'bold', marginBottom: '1rem', fontSize: '25px' }}>How To Reach Us?</h4>
            <ol style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <a 
                  href={`${baseUrl}/contact`} 
                  style={{ color: '#fff', textDecoration: 'none' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact Us
                </a>
              </li>
            </ol>
          </div>
        </div>

        {/* QALLIX Logo and Description */}
        <div style={{ 
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '2rem',
          padding: '0 1rem'
        }}>
          {/* QALLIX Logo */}
          <div style={{ 
            flex: '1 1 100%',
            textAlign: 'left'
          }}>
            <h2 style={{ 
              fontWeight: 'bold', 
              letterSpacing: '4px', 
              whiteSpace: 'nowrap',
              padding: '0'
            }}>
              Q A L L I X
            </h2>
          </div>

          {/* Description */}
          <div style={{ 
            flex: '1 1 100%'
          }}>
            <p style={{ 
              fontStyle: 'italic', 
              lineHeight: 1.5, 
              marginBottom: '1rem',
              width: '100%',
              maxWidth: '500px',
              padding: '1rem 0',
              textAlign: 'left',
              margin: '0'
            }}>
              A data-driven, AI learning multichannel cloud-based e-commerce management solution that helps you run your business more efficiently across several marketplaces.
            </p>
          </div>
        </div>

        {/* Social Icons */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1.5rem',
          marginBottom: '1.5rem'
        }}>
          <a 
            href="https://facebook.com/qallix" 
            style={{ color: '#fff', textDecoration: 'none' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon fontSize="medium" />
          </a>
          <a 
            href="https://instagram.com/qallix.official" 
            style={{ color: '#fff', textDecoration: 'none' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon fontSize="medium" />
          </a>
        </div>

        {/* Divider Line */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          margin: '2rem 0'
        }} />

        {/* Copyright */}
        <div style={{ 
          textAlign: 'left',
          padding: '0 1rem'
        }}>
          <p style={{ fontSize: '0.8rem' }}>
            © 2025, Qallix All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}